import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import type { DocumentErrorInfo } from '../utils/documentErrorCodes';

interface ErrorState {
    /** Текст ошибки для пользователя (любой источник). */
    error: string | null;
    /**
     * Структурированная ошибка парсинга/загрузки документа
     * (PARSER_ERRORS_FRONTEND.md §4/§6). Заполняется только для ошибок,
     * у которых есть errorCode/recoverable; для прочих ошибок — null.
     */
    info: DocumentErrorInfo | null;
}

const initialState: ErrorState = {
    error: null,
    info: null,
};

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        /**
         * Универсальная установка текстовой ошибки. ВАЖНО: всегда сбрасывает
         * структурный `info`, чтобы старая ошибка парсинга не «залипала» и не
         * показывала неверные кнопки (Повторить парсинг и т.п.).
         */
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.info = null;
        },
        /** Структурированная ошибка документа (с errorCode/recoverable). */
        setDocumentError: (state, action: PayloadAction<DocumentErrorInfo>) => {
            state.error = action.payload.message;
            state.info = action.payload;
        },
    },
});

export const selectError = (state: RootState) => state.error.error;
export const selectErrorInfo = (state: RootState) => state.error.info;

export const { setError, setDocumentError } = errorSlice.actions;
export default errorSlice.reducer;
